import { RouteObject } from 'react-router-dom';

export interface MenuItem extends RouteObject {
  name?: string; // 메뉴명
  path: string; // 메뉴 경로 (필수 값으로 변경)
  defaultTab?: boolean; // 기본 탭인지 여부
  tabPath?: string; // 탭 클릭시 이동 상대 경로 (`@components/Tab/PageTab.tsx` 참고)
  queryString?: string; // Path가 아닌 Query 값을 사용할 경우 사용 (이때 위의 tabPath 무시됨)
  children?: MenuItem[]; // 자식 메뉴
  dropdown?: boolean; // 드롭다운 메뉴로 표시할지 여부
  superAdminOnly?: boolean; // 총괄 매니저만 접근 가능
  systemAdminOnly?: boolean; // 시스템 관리자만 접근 가능
}

export const ContractMenu: MenuItem[] = [
  {
    path: '/contract',
    name: '계약관리',
    children: [],
  },
];

// export const BoardMenu: MenuItem[] = [
//   {
//     path: '/request',
//     name: '요청 게시판',
//     children: [],
//   },
// ];

export const ClientMenu: MenuItem[] = [
  {
    path: '/client',
    name: '고객사',
  },
  {
    path: '/client/new',
    name: '신규 고객사 등록',
  },
  {
    path: '/client/:clientId',
    name: '지점',
    children: [
      {
        path: '/client/:clientId/venue',
        tabPath: './venue',
        name: '지점 리스트',
      },
      {
        path: '/client/:clientId',
        tabPath: './',
        name: '고객사 정보',
      },
    ],
  },
  {
    path: '/client/:clientId/venue/new',
    name: '신규 지점 등록',
  },
  {
    path: '/client/:clientId/venue/:venueId/edit',
    name: '지점 정보 수정',
  },
];

export const VenueMenu: MenuItem[] = [
  {
    path: '/client/:clientId/venue/:venueId',
    name: '지점 정보',
    children: [
      {
        path: '/client/:clientId/venue/:venueId',
        name: '지점 정보',
        tabPath: './',
      },
      {
        path: '/client/:clientId/venue/:venueId/space',
        tabPath: './space',
        name: '공간 정보',
      },
    ],
  },
];

export const TaskMenu: MenuItem[] = [
  {
    path: '/task',
    name: '업무관리',
  },
  {
    path: '/task/client/:clientId/venue/:venueId',
    name: '업무관리',
    children: [
      {
        path: '/task/client/:clientId/venue/:venueId/',
        tabPath: './',
        name: '작업관리',
        children: [
          {
            path: '/task/client/:clientId/venue/:venueId/',
            queryString: '?type=periodic',
            name: '정기',
          },
          {
            path: '/task/client/:clientId/venue/:venueId/',
            queryString: '?type=onetime',
            name: '일회성',
          },
        ],
      },
      {
        path: '/task/client/:clientId/venue/:venueId/attendance',
        tabPath: './attendance',
        name: '근태관리',
      },
    ],
  },
];

export const WorkStatusMenu: MenuItem[] = [
  {
    path: '/work-status',
    name: '업무 현황',
  },
];

export const ChatMenu: MenuItem[] = [
  {
    path: '/chat',
    name: '문의/답변',
  },
  {
    path: '/chat/client/:clientId/venue/:venueId',
    name: '문의/답변',
  },
];

export const PartnersMenu: MenuItem[] = [
  {
    path: '/partners',
    name: '파트너스',
    children: [
      {
        path: '/partners/crews',
        tabPath: './crews',
        name: '크루',
      },
    ],
  },
];

export const MenuList: MenuItem[] = [
  {
    path: '/work-status',
    name: '업무현황',
  },
  {
    path: '/task',
    name: '업무관리',
  },
  {
    path: '/partners',
    name: '크루관리',
  },
  {
    path: '/client',
    name: '고객사관리',
    dropdown: true,
    children: [
      { path: '/client', name: '고객사', tabPath: './' },
      {
        path: '/client/manager/bulk-edit',
        name: '매니저변경',
        tabPath: './manager/bulk-edit',
      },
    ],
  },
  {
    path: '/contract',
    name: '계약관리',
  },
  // {
  //   path: '/request',
  //   name: '요청 게시판',
  // },
  {
    path: '/notices',
    name: '공지사항',
  },
  {
    path: '/chat',
    name: '문의/답변',
  },
  {
    path: '/report',
    name: '리포트',
    dropdown: true, // 드롭다운 메뉴로 표시
    children: [
      {
        path: '/report/not-uploaded',
        name: '미등록 크루',
        tabPath: './not-uploaded',
      },
      {
        path: '/report/monthly',
        name: '월별 제출율',
        tabPath: './monthly',
      },
      {
        path: '/report/attendance',
        name: '크루 출퇴근',
        tabPath: './attendance',
      },
      {
        path: '/report/manager-venues',
        name: '매니저별 고객사',
        tabPath: './manager-venues',
      },
    ],
  },
  {
    path: '/admin',
    name: '운영관리',
    dropdown: true,
    systemAdminOnly: true,
    children: [
      {
        path: '/admin/manager',
        name: '매니저 목록',
        tabPath: '/admin/manager',
        systemAdminOnly: true,
      },
      {
        path: '/admin/manager/new',
        name: '매니저 등록(어드민)',
        tabPath: '/admin/manager/new',
        systemAdminOnly: true,
      },
      {
        path: '/admin/crew/new',
        name: '크루 등록(어드민)',
        tabPath: '/admin/crew/new',
        systemAdminOnly: true,
      },
      {
        path: '/admin/cleanier/new',
        name: '클리니어 등록(어드민)',
        tabPath: '/admin/cleanier/new',
        systemAdminOnly: true,
      },
    ],
  },
];
